import roleIndex from '../../pages/role'

const RoleRoute = [
  {
    path: '/role',
    name: 'role',
    component: roleIndex
  }
]
export default RoleRoute



// WEBPACK FOOTER //
// ./src/router/role/index.js